import { defineMessages } from "react-intl";

const PREFIX = "Favourites.FavouritesMenu";

export const messages = defineMessages({
  noFavourites: {
    id: `${PREFIX}.noFavourites`,
    defaultMessage: "The Favourites section is empty",
  },
});
